// src/image.ts
var createImage = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/images`, { body: data, ...options }).json();
};
var createImageApi = (client, provider) => {
  return {
    createImage: createImage(client, provider)
  };
};

export {
  createImageApi
};
